export default {"src":"/_next/static/media/autopassapp.144d718b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};